<app-layout-row>
    <app-layout-column [width]="12">
        <h2>Add Conditions</h2>
        <p>If all following Conditions are met.</p>
    </app-layout-column>
</app-layout-row>

<ng-container ngModelGroup="conditions">
    @for (condition of conditions(); track condition.Id; let i = $index) {
    <fieldset [ngModelGroup]="condition.Id" #form="ngModelGroup">
        <app-layout-row>
            <app-layout-column [width]="12">
                <app-error-rules-condition 
                    [condition]="condition"
                    [conditionValueProvider]="getConditionValues"
                    [conditionTypeProvider]="getConditionTypes"
                    (onDeleteCondition)="deleteCondition(i)"
                    (onSummaryChange)="summaryChange($event,condition)" >
                </app-error-rules-condition>
                <hr>
            </app-layout-column>
        </app-layout-row>
    </fieldset>
    }
</ng-container>

<app-layout-row>
    <app-layout-column [width]="12">
        <app-link iconClass="dx-icon-add" (onClick)="addCondition()">Add Condition</app-link>
    </app-layout-column>
</app-layout-row>
